module.exports = __webpack_public_path__ + "img/m-logo-colour.245aeb3f.png";